import { useContext, useMemo } from 'react';
import type { Chat } from '@trinity/chat';
import { ActiveChatSessionContext, AuthorContext } from '../context';

// NOTE: This should only be used in places where the author of the chat instance is needed (not the current user)
export function useChatInstanceAuthor(): Chat.Author {
  const author = useContext(AuthorContext);
  const ctx = useContext(ActiveChatSessionContext);

  return useMemo(() => {
    if (!ctx.shared)
      return author;
    else
      return ctx.shared.sharedBy;
  }, [ctx.shared, author]);
}